import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

const schema = yup.object({})

const resChangePassword = yupResolver(schema)

export default resChangePassword
